import "./App.css";
import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import WorkflowInstanceList from './Components/Tab Content/Workflow InstanceList';
import WorkflowMapping from "./Components/Tab Content/Workflow Mapping";
import { initializeAuthListener } from "./API Service/initializeAuthListener";

function App() {
  const getQueryParam = (param) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  };

  useEffect(() => {
    const cleanup = initializeAuthListener();

    return cleanup;
  }, []);

  const selectedIndex = getQueryParam("selectedIndex");

  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={<Home selectedIndex={selectedIndex} />}
        />
        <Route
          path="/workflowinstance"
          element={<WorkflowInstanceList />}
        />
        <Route path="/workflow-mapping" element={<WorkflowMapping />} />
      </Routes>
    </div>
  );
}

export default App;
